"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Styles = {
    videoItem: (active) => core_1.css `
    background-color: ${active ? styles_scss_1.default.primary01 : styles_scss_1.default.white};
  `,
    videoItemLabel: (active) => core_1.css `
    color: ${active ? styles_scss_1.default.primary : styles_scss_1.default.darkGrey};
  `,
    videoItemDuration: (active) => core_1.css `
    color: ${active ? styles_scss_1.default.black : styles_scss_1.default.darkGrey};
  `,
    rightIcon: (completed) => core_1.css `
    height: ${completed ? styles_scss_1.default.l : styles_scss_1.default.s};
    width: ${completed ? styles_scss_1.default.l : styles_scss_1.default.s};
  `,
    questionItem: (active) => core_1.css `
    background-color: ${active ? styles_scss_1.default.primary01 : styles_scss_1.default.white};
  `,
    questionItemLabel: (active) => core_1.css `
    color: ${active ? styles_scss_1.default.primary : styles_scss_1.default.darkGrey};
  `,
    questionItemSmall: (active) => core_1.css `
    color: ${active ? styles_scss_1.default.black : styles_scss_1.default.darkGrey};
  `,
    sessionItem: (active) => core_1.css `
    background-color: ${active ? styles_scss_1.default.primary01 : styles_scss_1.default.white};
  `,
    sessionItemLabel: (active) => core_1.css `
    color: ${active ? styles_scss_1.default.primary : styles_scss_1.default.darkGrey};
  `,
    stepContainer: (isVideo, activeStep) => core_1.css `
    background-color: ${isVideo ? styles_scss_1.default.black : styles_scss_1.default.backgroundGrey};
    @media (max-width: ${styles_scss_1.default.mobileBreakpoint}) {
      display: ${activeStep ? "flex" : "none"} !important;
    }
    padding: ${isVideo ? 0 : "40px"};
    @media (max-width: ${styles_scss_1.default.tablet}) and (min-width: ${styles_scss_1.default.mobileBreakpoint}) {
      padding: ${isVideo ? 0 : "25px"};
    }
  `,
    layoutCloseBtn: (imageUrl) => core_1.css `
    background-image: ${`url(${imageUrl})`};
  `,
};
exports.default = Styles;
